import { CALL_API } from './../../middlewares/api';

const onLoadMinhasTarefas = () => ({
  [CALL_API]: {
    type: 'LIST_TASK',
    endpoint: 'agenda',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'my' }
    }
  }
});

const onLoadTodasTarefas = () => ({
  [CALL_API]: {
    type: 'LIST_ALL_TASKS',
    endpoint: 'agenda',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'all' }
    }
  }
});

const onLoadTodasTarefasConfigPerfis = () => ({
  [CALL_API]: {
    type: 'LIST_CONFIG_PERFIS_TASKS',
    endpoint: 'agenda',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'config_perfis' }
    }
  }
});

const onLoadTodasTarefasConfigIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_CONFIG_TASKS',
    endpoint: 'agenda',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'config' }
    }
  }
});

const onLoadTodasTarefasConfig = () => (dispatch, getState) => {
  let { fetching, errors = [] } = getState().agenda.config;

  if (!fetching && !errors.length) {
    return dispatch(onLoadTodasTarefasConfigIfNeeded());
  }

  return Promise.resolve();
};

const onLoadQrCodes = () => ({
  [CALL_API]: {
    type: 'LIST_QRCODE_TASKS',
    endpoint: 'agenda',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'qrcode' }
    }
  }
});

const onConfirmTask = ({ value, ...otherProps }) => ({
  [CALL_API]: {
    type: 'CONFIRM_TASK',
    endpoint: 'agenda',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { type: 'confirm-task' },
      body: {
        id_tarefa_dia: value.id_tarefa_dia,
        id_tarefa_avulsa: value.id_tarefa_avulsa,
        categoria: "TASK_DONE",
        ...otherProps
      }
    }
  },
  value
});

const onSaveConfigTask = ({ value }) => ({
  [CALL_API]: {
    type: 'SAVE_CONFIG_TASK',
    endpoint: 'agenda',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { type: 'config' },
      body: {
        value,
      }
    }
  },
  value
});

const onSaveQrcodeTask = ({ value }) => ({
  [CALL_API]: {
    type: 'SAVE_QRCODE_TASK',
    endpoint: 'agenda',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { type: 'qrcode' },
      body: {
        value,
      }
    }
  },
  value
});

const updatePerfil = (value) => ({
  [CALL_API]: {
    type: 'UPDATE_CONFIG_PERFIL_TASK',
    endpoint: 'agenda',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { type: 'config_perfis' },
      body: {
        value,
      }
    }
  },
  value
});

export default {
  onLoadTodasTarefasConfigPerfis,
  onLoadTodasTarefasConfig,
  onLoadMinhasTarefas,
  onLoadTodasTarefas,
  onConfirmTask,
  onLoadQrCodes,
  onSaveQrcodeTask,
  onSaveConfigTask,
  updatePerfil
};


// WEBPACK FOOTER //
// ./src/modules/agenda/actions.js